import Flowchart from './containers/FlowchartContainer';

export default Flowchart;
